// flags
import { normalizeFeatureFlags } from "../feature-flag";

// services
export { defaultConfig, alwaysOnFeatures } from "./default";

// types
import { RemoteConfigType } from "./types";

export type { RemoteConfigType } from "./types";

export function deriveFeatureFlags(config: RemoteConfigType) {
  return normalizeFeatureFlags(config);
}

export function parseRemoteFetch(
  defaultConfig: RemoteConfigType,
  // oxlint-disable-next-line typescript/no-explicit-any
  remote: Record<string, any>,
): RemoteConfigType {
  return Object.entries(remote).reduce(
    (conf, [key, val]) => {
      switch (typeof defaultConfig[key as keyof typeof defaultConfig]) {
        case "boolean":
          conf[key] = val.asBoolean();
          break;
        case "number":
          conf[key] = val.asNumber();
          break;
        default:
          conf[key] = val.asString();
      }
      return conf;
    },
    // oxlint-disable-next-line typescript/no-explicit-any
    { ...defaultConfig } as any,
  ) as RemoteConfigType;
}
